<template>
  <BaseContainer
    class="dnnCloud-account-box"
    :loading="listLoading"
    :isHasPageFt="!listLoading"
  >
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <!-- <el-form-item>
                <el-select v-model="value" placeholder="请选择" @change="changeSouch"  style="width:120px; margin-top: 0">
                  <el-option v-for="item in optionsSouch" :key="item.value"  
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item> -->

          <el-form-item>
            <el-input
              v-model="searchName"
              placeholder="账号 / 姓名 / 企业"
              style="width: 155px"
              clearable
              @keyup.enter.native="getUser(1)"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <!-- <el-select  v-model="souchs.softtype" placeholder="软件类型" style="width:180px;" clearable >
                  <el-option v-for="item in softtypes" :key="item.value" 
                    :label="item.label" :value="item.value" :title="item.label">
                  </el-option>
                </el-select> -->

            <el-select
              v-model="isCompanyUser"
              placeholder="用户类型"
              style="width: 140px"
              clearable
            >
              <el-option label="个人用户" value="1"> </el-option>
              <el-option label="企业用户" value="2"> </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item>
                  <el-select v-model="souchs.invitValue" placeholder="邀请状态" style="width:105px;" clearable >
                    <el-option v-for="item in inviValues" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>  -->

          <el-form-item>
            <el-date-picker
              style="width: 140px"
              v-model="souchs.fromtime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-date-picker
              style="width: 140px"
              v-model="souchs.totime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1" style="width: 130px">
            <SelectCommon
              placeholder="客户经理"
              style="width: 100%"
              :clearable="true"
              apiPath="/tbAdminuser/manageList"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="managerAdminuser"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'managerAdminuser')
              "
            />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1">
            <SelectCommon
              placeholder="客户成功经理"
              style="width: 130px"
              :clearable="true"
              apiPath="/tbAdminuser/list"
              :params="{ type: 3 }"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="successfulManager"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'successfulManager')
              "
            />
          </el-form-item>

          <el-form-item v-if="userInfo.type == 1">
            <SelectCommon
              placeholder="经销商"
              style="width: 130px"
              :clearable="true"
              apiPath="/tbAdminuser/list"
              :params="{ type: 4 }"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="agencyManager"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'agencyManager')
              "
            />
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="distributionStatus"
              placeholder="是否分配"
              style="width: 120px"
              clearable
            >
              <el-option
                v-for="item in distribution"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" @click="getUser(1)"
              >查询</el-button
            >

            <el-button type="primary" size="medium" @click="addUser(1)"
              >新增</el-button
            >

            <el-button type="primary" size="medium" @click="addUser(2)"
              >批量导入</el-button
            >

            <el-button type="text"><a :href="downHref">下载模板</a></el-button>

            <el-button type="text" v-if="userInfo.type == 1"
              ><a :href="downHrefExcel">导出</a></el-button
            >

            <input
              type="file"
              id="uploadwxsModal"
              style="display: none"
              name="file"
              ref="clearFileModal"
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="fileInputChange($event)"
            />
          </el-form-item>
        </el-form>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-button
          v-if="dynamicTags != ''"
          class="button-new-tag"
          size="small"
          @click="delTags"
          >清除标签</el-button
        >
      </el-col>
    </template>

    <template v-slot:main>
      <!--列表-->
      <el-table
        :data="users"
        highlight-current-row
        :height="maxTbHeight"
        :header-cell-style="getRowClass"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        >
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="账号"
          min-width="100"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="积分"
          width="100"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope"> {{ scope.row.point || "-" }} </template>
        </el-table-column>
        <el-table-column prop="registertime" label="注册日期" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="softtype"
          label="软件类型"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column prop="productTypeName" label="类型">
          <template slot-scope="scope">
            <div class="purple" v-if="scope.row.productType === '1'">
              {{ scope.row.productTypeName }}
            </div>
            <div class="blue" v-else-if="scope.row.productType === '2'">
              {{ scope.row.productTypeName }}
            </div>
            <div class="gray" v-else>{{ scope.row.productTypeName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="company"
          label="企业"
          min-width="180"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="adminName"
          label="客户经理"
          min-width="100"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.adminName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="adminName"
          label="客户成功经理"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.successfulManagerName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="adminName"
          label="经销商"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.agencyManagerName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="adminName"
          label="是否联系过"
          min-width="100"
          sortable="hasNote"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.hasNote == 0 ? "否" : "是" }}
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          style="text-algin: center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span class="operate">
              <el-tooltip effect="dark" content="详情" placement="top">
                <span
                  class="dnnfont iconfile-search"
                  @click="readUser(scope.$index, scope.row)"
                ></span>
              </el-tooltip>

              <el-tooltip effect="dark" content="编辑" placement="top">
                <span
                  class="dnnfont iconEdit"
                  @click="handleEdit0(scope.$index, scope.row)"
                ></span>
              </el-tooltip>

              <!-- canYouDel=1可以删除0不能删除 -->
              <el-tooltip
                effect="dark"
                content="删除"
                placement="top"
                v-if="scope.row.canYouDel == 1"
              >
                <span
                  class="dnnfont icondelete"
                  @click="handledel(scope.$index, scope.row)"
                ></span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <!--修改界面-->
      <el-dialog
        class="model-edit model-user-box"
        width="850px"
        :title="asTitle"
        :visible.sync="editFormVisible0"
        :close-on-click-modal="false"
        v-if="editFormVisible0"
        @close="dialogClose"
      >
        <el-row :gutter="24">
          <el-form
            :model="editForm0"
            ref="editForm0"
            label-width="100px"
            :rules="rules"
          >
            <el-col :span="12" v-if="modalType != 2">
              <el-form-item label="账号" prop="phone">
                <el-input
                  v-model="editForm0.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="modalType != 2">
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="editForm0.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="软件类型" prop="code">
                <el-select v-model="editForm0.code" style="width: 100%">
                  <el-option
                    v-for="item in yhlx"
                    :label="item.text"
                    :key="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="用户类型" prop="userType">
                <el-select
                  v-model="editForm0.userType"
                  style="width: 100%"
                  @change="(val) => handerChange(val, 'addCode')"
                >
                  <el-option label="个人用户" value="0"> </el-option>
                  <el-option label="企业用户" value="1"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Bug #96: 客户经理登录默认是自己，不可修改， 系统管理员登录可选择客户经理 -->
            <el-col :span="12">
              <el-form-item label="客户经理">
                <SelectCommon
                  placeholder="请选择"
                  style="width: 100%"
                  :clearable="true"
                  apiPath="/tbAdminuser/manageList"
                  :keys="{ label: 'name', value: 'id' }"
                  :key="curCompanyId || addCode == 0"
                  :disabled="
                    addCode == 1 || (addCode == 0 && userInfo.type != 1)
                  "
                  :selectFirst="addCode == 1 && editForm0.companyuseid != ''"
                  :defaultVal="
                    addCode == 0 && editForm0.managerAdminuser
                      ? editForm0.managerAdminuser
                      : ''
                  "
                  :params="{
                    ComId: addCode == 1 ? editForm0.companyuseid : '',
                  }"
                  @change="
                    (value, datas) =>
                      handleSelectCommon(value, datas, 'managerAdminuser')
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="客户成功经理">
                <SelectCommon
                  placeholder="请选择"
                  style="width: 100%"
                  :clearable="true"
                  :apiPath="
                    addCode == 1
                      ? '/tbAdminuser/getAdminUserByComId'
                      : '/tbAdminuser/list'
                  "
                  :params="
                    addCode == 1
                      ? {
                          userType: 3,
                          ComId: addCode == 1 ? editForm0.companyuseid : '',
                        }
                      : { type: 3 }
                  "
                  :keys="{ label: 'name', value: 'id' }"
                  :key="curCompanyId || addCode == 0"
                  :disabled="
                    addCode == 1 || (addCode == 0 && userInfo.type != 1)
                  "
                  :selectFirst="addCode == 1 && editForm0.companyuseid != ''"
                  :defaultVal="
                    addCode == 0 && editForm0.successfulManager
                      ? editForm0.successfulManager
                      : ''
                  "
                  @change="
                    (value, datas) =>
                      handleSelectCommon(value, datas, 'successfulManager')
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="经销商">
                <!-- :selectFirst="addCode == 1 && editForm0.companyuseid != ''" -->
                <SelectCommon
                  placeholder="请选择"
                  style="width: 100%"
                  :clearable="true"
                  :apiPath="
                    addCode == 1
                      ? '/tbAdminuser/getAdminUserByComId'
                      : '/tbAdminuser/list'
                  "
                  :params="
                    addCode == 1
                      ? {
                          userType: 4,
                          ComId: addCode == 1 ? editForm0.companyuseid : '',
                        }
                      : { type: 4 }
                  "
                  :keys="{ label: 'name', value: 'id' }"
                  :key="curCompanyId || addCode == 0"
                  :disabled="
                    addCode == 1 || (addCode == 0 && userInfo.type != 1)
                  "
                  :selectFirst="addCode == 1 && editForm0.companyuseid != ''"
                  :defaultVal="
                    addCode == 0 && editForm0.agencyManager
                      ? editForm0.agencyManager
                      : ''
                  "
                  @change="
                    (value, datas) =>
                      handleSelectCommon(value, datas, 'agencyManager')
                  "
                />
              </el-form-item>
            </el-col>

            <!-- 个人用户： 输入企业 -->
            <el-col :span="24" v-if="addCode == 0">
              <el-form-item label="所属企业" prop="company">
                <el-input
                  v-model="editForm0.company"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 企业用户： 选择企业 -->
            <el-col :span="24" v-if="addCode == 1">
              <el-form-item label="所属企业" prop="companyuseid">
                <el-select
                  v-model="editForm0.companyuseid"
                  style="width: 100%"
                  @change="(val) => handerChange(val, 'curCompanyId')"
                  filterable
                >
                  <el-option
                    v-for="item in companyList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 部门 -->
            <el-col
              :span="24"
              v-show="
                editForm0.userType &&
                editForm0.userType == '1' &&
                modalType == '2'
              "
            >
              <el-form-item label="部门">
                <el-select
                  v-model="deptId"
                  placeholder="部门"
                  style="width: 140px"
                  class="souch_change souch_input"
                  clearable
                >
                  <el-option
                    v-for="item in detpList"
                    :key="item.value"
                    :label="item.deptname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="客户地址" prop="longitudeAndLatitude">
                <GisCommon
                  ref="GisCommon"
                  :selected="editForm0.selected"
                  :address="editForm0.address"
                  :lonLat="editForm0.longitudeAndLatitude"
                  @backPram="backPram"
                ></GisCommon>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="用户密码" prop="passwordMo">
                <el-input
                  v-model="editForm0.passwordMo"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-if="modalType == 2">
              <el-form-item label="文件" prop="fileUploadName">
                <el-button
                  type="primary"
                  style="padding-left: 0; padding-right: 0"
                  ><label
                    for="uploadwxsModal"
                    style="padding: 12px 20px; cursor: pointer"
                    >选择文件</label
                  ></el-button
                >
                <div>{{ fileUploadName }}</div>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="cancelHandler">取消</el-button>
          <el-button
            type="primary"
            v-if="modalType != 2"
            @click.native="editSubmit0('editForm0')"
            :loading="editLoading0"
            >提交</el-button
          >
          <el-button
            type="primary"
            v-if="modalType == 2"
            @click.native="importFile('editForm0')"
            :loading="editLoading0"
            >提交</el-button
          >
        </div>
      </el-dialog>

      <!--授权界面-->
      <el-dialog
        class="model-edit"
        title="编辑"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :model="editForm" label-width="80px" ref="editForm">
          <el-form-item label="试用模块" prop="title">
            <div
              style="
                background: rgb(244, 255, 243);
                width: 90%;
                height: 300px;
                overflow: auto;
                border: 1px solid #dfe6ec;
              "
            >
              <el-checkbox-group
                v-model="editForm.checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  style="
                    float: left;
                    clear: left;
                    margin-left: 20px;
                    position: relative;
                    top: 0px;
                  "
                  v-for="city in cities"
                  :label="city"
                  :key="city"
                  >{{ city }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="试用期限" prop="origin">
            <el-select v-model="editForm.value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>

      <!--审批界面-->
      <el-dialog
        class="model-edit"
        title="审批"
        :visible.sync="appFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :model="appForm" label-width="80px" ref="appForm">
          <el-form-item label="试用模块" prop="title">
            <div
              style="
                background: rgb(244, 255, 243);
                width: 90%;
                height: 300px;
                overflow: auto;
              "
            >
              <el-checkbox-group
                v-model="appForm.checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  style="
                    float: left;
                    clear: left;
                    margin-left: 20px;
                    position: relative;
                    top: 0px;
                  "
                  v-for="city in cities"
                  :label="city"
                  :key="city"
                  >{{ city }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="试用期限" prop="origin">
            <el-select v-model="appForm.value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button
            type="primary"
            @click.native="appSubmit"
            :loading="appLoading"
            >通过</el-button
          >
          <el-button
            type="danger"
            @click.native="falseSubmit"
            :loading="falseLoading"
            >驳回</el-button
          >
        </div>
      </el-dialog>
    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50, 100]"
          :current-page="pageNumber"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-size="pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { API__code, API_User, API_Models, API_Admin, API_Menu, API_userCom } from '../../../api/index.js'
import axios from 'axios'
import BaseContainer from '@/components/BaseContainer'
import SelectCommon from '@/components/SelectCommon'
import GisCommon from '@/components/GisCommon'
const cityOptions = ['模块1', '模块2', '模块3', '模块4', '模块5', '模块6'];
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data() {

    // 新增用户校验客户经理
    // var validateManager = (rule, value, callback) => {
    //     if (value === '') {
    //       callback(new Error('请选择客户经理'));
    //     } else {
    //       if (this.editForm0.managerAdminuser !== '') {
    //         this.$refs.editForm0.validateField('managerAdminuser');
    //       }
    //       callback();
    //     }
    // };

    // 新增用户校验客户地址
    var validateAddress = (rule, value, callback) => {
      if (this.editForm0.longitudeAndLatitude === '') {
        callback(new Error('请填写客户地址'));
      } else {
        if (this.editForm0.province == '' || this.editForm0.city == '' || this.editForm0.district == '' || this.editForm0.addressInfo == '') {
          this.$refs.editForm0.validateField('longitudeAndLatitude');
        }
        callback();
      }
    };

    // 校验手机号码是否被注册 editForm0.phone
    var validatoPhone = async (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/
      if (!this.editForm0.phone) {
        callback("请输入手机号")
      // } else if (!/^1[3456789]\d{9}$/.test(this.editForm0.phone)) {
      } else if (!reg.test(this.editForm0.phone)) {
        callback(new Error("请输入正确的手机号"));
      }
      else {
        if (this.oldPhone != this.editForm0.phone) {
          let res = await this.checkPhone(this.editForm0.phone);
          !res ? callback('当前手机号已被注册') : callback();
        }
      }
    }


    return {
      downHrefExcel: '',//用户导出
      downHref: '',
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      searchName: this.$route.query.searchName ? this.$route.query.searchName : '',
      dynamicTags: [],
      optionsSouch: [
        { value: '账号', label: '账号' },
        { value: '姓名', label: '姓名' },
        { value: '企业', label: '企业' },
        { value: '软件类型', label: '软件类型' },
        { value: '邀请状态', label: '邀请状态' },
        { value: '开始日期', label: '开始日期' },
        { value: '结束日期', label: '结束日期' },
      ],
      value: '',
      inviValues: [],
      softtypes: [],
      yhlx: [],
      zhlx: [],
      editLoading0: false,

      /**新增、修改用户 start **/
      editForm0: {
        managerAdminuser: '',   // 客户经理
        successfulManager:"",
        agencyManager:"",
        userType: 0,
        code: 0,

        // 客户地址
        province: '',          // 省
        city: '',              // 市
        district: '',          // 区
        longitudeAndLatitude: '', // 经纬度
        addressInfo: '',       // 详细地址

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' }, // ['110000', '130200', '140100']
        address: '',
        companyuseid: '',
        company: '',

        fileUploadName: ''
      },

      curCompanyId: '',

      editFormVisible0: false, //修改界面
      rules: {
        phone: [
          //   { required: true,message: '请输入手机号码'},
          //   {validator:function(rule,value,callback){
          //     if(/^1[3456789]\d{9}$/.test(value) == false){
          //         callback(new Error("请输入正确的手机号"));
          //     }else{
          //         callback();
          //     }
          //  }, trigger: 'change'},
          { required: true, validator: validatoPhone, trigger: 'change' },

        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        code: [
          { required: false, message: '请选择软件类型', trigger: 'change' }
        ],
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'change' }
        ],
        company: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        companyuseid: [
          { required: true, message: '请选择企业', trigger: 'change' }
        ],
        passwordMo: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],

        managerAdminuser: [
          // { required: true, validator: validateManager, trigger: 'change' }
          { required: true, message: '请选择客户经理', trigger: 'change' }
        ],

        longitudeAndLatitude: [
          { required: true, validator: validateAddress, trigger: 'change' }
        ],

      },
      addCode: '0',    // 用户类型： 1个人用户 2：企业用户
      /**新增、修改用户 END **/

      falseLoading: false,
      cities: [],
      citiesd: [],
      userModule: [],
      editFormVisible: false,
      editForm: {},
      editLoading: false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        fromtime: this.$route.query.fromtime ? this.$route.query.fromtime : '',
        totime: this.$route.query.totime ? this.$route.query.totime : '',
      },
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      total: 0,
      users: [],

      appFormVisible: false,
      appForm: {
        checkedCities: [],
        value: '',
      },
      appLoading: false,

      editForm: {
        checkedCities: [],
        value: '',
      },

      asTitle: '编辑',
      modalType: 0,
      fileFormData: '',

      companyList: [],
      fileUploadName: '',
      oldPhone: '',    // 手机号码备份： 用于编辑时手机号码没修改放过校验
      managerAdminuser: this.$route.query.managerAdminuser ? this.$route.query.managerAdminuser : '',  // 新增客户经理过滤
      isCompanyUser: this.$route.query.isCompanyUser ? this.$route.query.isCompanyUser : '',     // 1 个人 2 企业用户
      successfulManager:'',
      agencyManager:"",
      distribution: [
        { value: '0', label: '未分配' },
        { value: '1', label: '已分配' }
      ],
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      deptId: '',
      detpList: [],
    }
  },

  computed: {
    ...mapGetters(['userInfo',]),
  },

  components: {
    BaseContainer,
    SelectCommon,
    GisCommon
  },

  created() {
    this.getCookie();
    this.getCode1();
    this.getCode2();
    if (this.$route.query.type == 1) {
      this.dynamicTags = this.$route.query.dynamicTags?JSON.parse(this.$route.query.dynamicTags):'';
      this.souchs = this.$route.query.souchs?JSON.parse(this.$route.query.souchs):{};
      this.pageNumber = this.$route.query.pageNumber?JSON.parse(this.$route.query.pageNumber):1;
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = API_Admin.userExcelTemplate() + "?token=" + this.token + "&checkCode=" + this.checkCode;

  },

  methods: {
    // 校验手机号是否被注册：true 唯一 false 不唯一
    checkPhone(phone) {
      return API_Admin.checkPhoneUnique({ phone }).then(res => {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(err => {
        return true;
      })
    },

    handerChange(val, key) {
      this.detpList = [];
      if (key == 'addCode') {
        this.addCode = val + ''
        this.editForm0.userType = this.addCode;
        // 切换用户类型： 0： 个人用户 1： 企业用户
        this.curCompanyId = ''
        this.editForm0.company = ''
        this.editForm0.companyuseid = ''
        this.editForm0.managerAdminuser = this.userInfo.type == 2 ? this.userInfo.id : '';
        this.editForm0.successfulManager = this.userInfo.type == 3 ? this.userInfo.id : '';
        this.editForm0.agencyManager = this.userInfo.type == 4 ? this.userInfo.id : '';

        // 切换用户类型： 设置客户地址默认位置
        // province: '320000', city: '320100', area: '320115', town: ''
        this.initMap({
          addressInfo: '',
          longitudeAndLatitude: '',
          province: "{\"key\":\"320000\",\"value\":\"江苏省\"}",
          city: "{\"key\":\"320100\",\"value\":\"南京市\"}",
          district: "{\"key\":\"320115\",\"value\":\"江宁区\"}"
        });
      } else {
        this[key] = val;
        // 切换企业
        if (key == 'curCompanyId') {
          // companyList
          let data = this.companyList.find(item => item.id == val)
          this.initMap(data);
          this.getDeptList(val);
        }
      }
    },

    importFile(form) {
      let _self = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          var file = this.fileFormData;
          if (!file) {
            _self.$message.error('请选择文件');
            return;
          }
          // this.listLoading = true;
          var formData = new FormData();
          formData.append("file", file);
          let createAdminUser = this.userInfo.id;
          var password = this.editForm0.passwordMo ? this.editForm0.passwordMo : '123456';
          var companyuseid = '';
          var company = '';
          var addCode = this.addCode;
          var code = this.editForm0.code;
          if (this.addCode == 1) {
            //formData.append("companyuseid", this.editForm0.companyuseid);
            companyuseid = this.editForm0.companyuseid;
            var list = Object.assign([], this.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == this.editForm0.companyuseid) {
                name = list[p].name
              }
            }
            formData.append("company", name);
            company = decodeURIComponent(name);
          } else {
            // formData.append("companyuseid", '');
            formData.append("company", this.editForm0.company);
            companyuseid = '';
            // company = decodeURIComponent(this.editForm0.company);
          }
          this.editLoading0 = true;
          var _this = this;

          let { province, city, district } = this.editForm0

          formData.append("addressInfo", this.editForm0.addressInfo);
          formData.append("city", city);
          formData.append("province", province);
          formData.append("district", district);
          let param = `usertype=${addCode}&password=${password}&companyuseid=${companyuseid}&code=${code + ''}&createAdminUser=${createAdminUser}&longitudeAndLatitude=${this.editForm0.longitudeAndLatitude}&deptid=${this.deptId}&managerAdminuser=${this.editForm0.managerAdminuser}&successfulManager=${this.editForm0.successfulManager}&agencyManager=${this.editForm0.agencyManager}`


          API_Admin.importUserExcelfile(param,formData)
            .then((res) => {
              if (res.data.code == '401') {
                _this.$message.error(res.data.message);
              } else {
                _this.$message.success('导入成功！');
                _this.getUser();
                _this.$refs.clearFileModal.value = "";
                _this.editFormVisible0 = false;
                _this.$refs[form].resetFields();
                _this.deptId=''
              }
              _this.editLoading0 = false;
            })
            .catch((err) => {
              _this.$message.error('导入失败！');
              _this.editLoading0 = false;
            })
        } else {
          return false
        }
      })
    },

    fileInputChange(files) {
      var file = files.target.files[0];
      var type = file.type;
      if (
        type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        type == "application/vnd.ms-excel"
      ) {
        this.fileFormData = file;
        this.fileUploadName = file.name;
        this.$refs.clearFileModal.value = "";
        // this.importFile();
      } else {
        this.$message.error('请上传xlsx/xls格式文件！');
      }
    },

    // 客户地址
    backPram(param) {

      this.editForm0.province = JSON.stringify(param.selected.province)
      this.editForm0.city = JSON.stringify(param.selected.city)
      this.editForm0.district = JSON.stringify(param.selected.area)
      this.editForm0.longitudeAndLatitude = param.position.toString()
      this.editForm0.addressInfo = param.address
      this.editForm0.selected = {
          area: this.editForm0.district,
          city: this.editForm0.city,
          province: this.editForm0.province,
          town: ''
      }
      this.$refs.editForm0.validateField('longitudeAndLatitude');
    },

    // 客户经理过滤
    handleSelectCommonFilter(value, datas, key) {
      this[key]=value[0]
    },

    // 客户经理
    handleSelectCommon(value, datas, key) {
      this.editForm0[key] = value[0]
      this.$refs.editForm0.validateField(key);
    },

    addUser(type) {
      this.asTitle = type == 1 ? '新增' : '导入';
      this.editFormVisible0 = true;
      this.modalType = type;
      // 新增和导入密码必填
      this.rules.passwordMo[0].required = true;

      this.editForm0 = {
        managerAdminuser: this.userInfo.type == 2 ? this.userInfo.id : '',   // 客户经理
        successfulManager: this.userInfo.type == 3 ? this.userInfo.id : '',  // 客户成功经理
        agencyManager: this.userInfo.type == 4 ? this.userInfo.id : '',      // 经销商
        code: 0,
        // 客户地址
        province: '',          // 省
        city: '',              // 市
        district: '',          // 区
        longitudeAndLatitude: '', // 经纬度
        addressInfo: '',       // 详细地址

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' }, // ['110000', '130200', '140100']
        address: '',
        company: '',
      },
        this.addCode = '0'
      this.editForm0.userType = '0'
      this.fileUploadName = '';
      this.$refs['editForm0'] && this.$refs['editForm0'].resetFields();
    },

    handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags: function () {
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    readUser: function (index, row) {
      this.$router.push({
        path: '/userDetail',
        query: {
          userId: row.id,
          name: row.name,
          dynamicTags: JSON.stringify(this.dynamicTags),
          souchs: JSON.stringify(this.souchs),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          searchName: this.searchName,
          isCompanyUser: this.isCompanyUser,
          fromtime: this.souchs.fromtime,
          totime: this.souchs.totime,
          managerAdminuser: this.managerAdminuser,
          distributionStatus: this.distributionStatus,
          phone:row.phone
        }
      });
    },

    changeSouch: function (val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    handleSortChange: function (val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "softtype") {
          this.orderStr = "codeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        } else if (val.prop == "adminName") {
          this.orderStr = "managerAdminuser";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    falseSubmit: function () {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let hours = nowDate.getHours();
      let minutes = nowDate.getMinutes();
      let seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      // 默认日期赋值
      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - (Math.abs(month2) % 12);
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        //day2 = days2;
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": false,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,
        //userModule:JSON.stringify(userModuled),
        userModule: [],
      }
      this.appLoading = true;
      API_Admin.setUserModule(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '审批成功',
              type: 'success'
            });
            this.appFormVisible = false;
            this.getUser();
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
          this.appLoading = false;
        }).catch(err => {
          this.$message.error('数据丢失，试试重新登陆！');
          this.appLoading = false;
        });
    },

    editSubmit: function () {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let hours = nowDate.getHours();
      let minutes = nowDate.getMinutes();
      let seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      // 默认日期赋值
      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.editForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - (Math.abs(month2) % 12);
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        //day2 = days2;
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.editForm.value,
        "module": this.userModule
      };
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.editForm.id,
        userModule: JSON.stringify(userModuled),
      }
      this.editLoading = true;
      API_Admin.setUserModule(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '授权成功',
              type: 'success'
            });
            this.editFormVisible = false;
            this.getUser();
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
          this.editLoading = false;
        }).catch(err => {
          this.$message.error('数据丢失，试试重新登陆！');
          this.editLoading = false;
        });

    },

    appSubmit: function () {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let hours = nowDate.getHours();
      let minutes = nowDate.getMinutes();
      let seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      // 默认日期赋值
      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - (Math.abs(month2) % 12);
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        //day2 = days2;
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,
        userModule: JSON.stringify(userModuled),
        moduleStatus: '1',
        phone: this.token,
      }
      this.appLoading = true;
      API_Admin.setUserModule(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '审批成功',
              type: 'success'
            });
            this.appFormVisible = false;
            this.getUser();
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
          this.appLoading = false;
        }).catch(err => {
          this.$message.error('数据丢失，试试重新登陆！');
          this.appLoading = false;
        });
    },

    //修改提交
    editSubmit0: function (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let param;

          this.editLoading0 = true;
          var methods = 'modifyUser'
          if (this.modalType == 1) {
            methods = 'addUserSingle';
            param = {
              token: this.token,
              checkCode: this.checkCode,
              mode: 'update',
              name: this.editForm0.name,
              phone: this.editForm0.phone,
              code: this.editForm0.code,
              company: this.editForm0.company,
              id: this.editForm0.id,
              userType: this.addCode,
              password: this.editForm0.passwordMo ? this.editForm0.passwordMo : '',
              companyuseid: '',

              province: this.editForm0.province,
              city: this.editForm0.city,
              district: this.editForm0.district,
              longitudeAndLatitude: this.editForm0.longitudeAndLatitude,
              addressInfo: this.editForm0.addressInfo,
              managerAdminuser: this.editForm0.managerAdminuser,
              createAdminUser: this.userInfo.id,
              successfulManager: this.editForm0.successfulManager,  // 客户成功经理
              agencyManager: this.editForm0.agencyManager,      // 经销商
            }
            param['password'] = this.editForm0.passwordMo ? this.editForm0.passwordMo : '123456'
          } else {
            param = {
              token: this.token,
              checkCode: this.checkCode,
              mode: 'update',
              name: this.editForm0.name,
              phone: this.editForm0.phone,
              code: this.editForm0.code,
              company: this.editForm0.company,
              id: this.editForm0.id,
              usertype: this.addCode,
              password: this.editForm0.passwordMo ? this.editForm0.passwordMo : '',
              companyuseid: '',

              province: this.editForm0.province,
              city: this.editForm0.city,
              district: this.editForm0.district,
              longitudeAndLatitude: this.editForm0.longitudeAndLatitude,
              addressInfo: this.editForm0.addressInfo,
              managerAdminuser: this.editForm0.managerAdminuser,
              createAdminUser: this.userInfo.id,
              successfulManager: this.editForm0.successfulManager,  // 客户成功经理
              agencyManager: this.editForm0.agencyManager,      // 经销商
            }
            param['registertime'] = this.editForm0.registertimeyuan
          }


          if (this.addCode == 1) {
            param['companyuseid'] = this.editForm0.companyuseid;
            var list = Object.assign([], this.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == this.editForm0.companyuseid) {
                name = list[p].name
              }
            }
            param['company'] = name;
          }

          API_Admin[methods](param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: this.modalType == 0 ? '修改成功' : '新增成功',
                  type: 'success'
                });
                this.editFormVisible0 = false;
                this.$refs[form].resetFields();
                this.getUser();
              } else {
                this.$message.error(res.data.message);
                this.editForm0.passwordMo = ''
                if (res.data.code == 403) {
                  this.$router.push({ path: 'loginAdmin' });
                }
              }
              this.editLoading0 = false;
            }).catch(err => {
              this.$message.error('数据丢失，试试重新登陆！');
              this.editLoading0 = false;
            });

        } else {
          return false;
        }
      })
    },

    // 初始化地图
    initMap(mapData) {
      let mapDataBack = JSON.parse(JSON.stringify(mapData))
      try {
        let { province, city, district, addressInfo, longitudeAndLatitude = '' } = mapData;
        province = JSON.parse(province)
        city = JSON.parse(city)
        district = JSON.parse(district)
        setTimeout(() => {
          this.editForm0.selecteds = { province: province.key, city: city.key, area: district.key, town: '' }
          this.editForm0.address = addressInfo;
          this.$refs.GisCommon.changePro(this.editForm0.selecteds)
          this.$refs.GisCommon.changItem(addressInfo)
          longitudeAndLatitude = longitudeAndLatitude ? longitudeAndLatitude.split(',').map(item => parseInt(item)) : ''
          this.$refs.GisCommon.changePos(longitudeAndLatitude)

          this.editForm0.longitudeAndLatitude = typeof longitudeAndLatitude === 'string' ? longitudeAndLatitude : longitudeAndLatitude.join();
          this.editForm0.province = mapDataBack.province
          this.editForm0.city = mapDataBack.city
          this.editForm0.district = mapDataBack.district
          this.editForm0.addressInfo = mapDataBack.addressInfo

          this.$refs.editForm0.validateField('longitudeAndLatitude');
        }, 100)
      } catch (e) {
        this.editForm0.selecteds = { province: '320000', city: '320100', area: '320115', town: '' }
        this.editForm0.address = '';
      }
    },

    //修改
    handleEdit0: function (index, row) {
      this.editFormVisible0 = true;
      this.asTitle = '编辑'
      this.modalType = 0;
      // 编辑密码非必填
      this.rules.passwordMo[0].required = false;
      this.editForm0 = Object.assign({}, row);
      this.addCode = this.editForm0.companyuseid ? '1' : '0'
      // this.editForm0.userType = row.usertype  // 为什么不返回userType？
      this.editForm0.userType = this.addCode
      this.oldPhone = this.editForm0.phone
      this.initMap(row);
    },

    //删除
    handledel: function (index, row) {
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token: this.token,
          checkCode: this.checkCode,
          id: row.id,
        }
        API_Admin.delUser(param)
          .then((res) => {
            if (res.data.code == API__code.SUCCESS) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getUser();
            } else {
              this.$message.error(res.data.message);
              if (res.data.code == 403) {
                this.$router.push({ path: 'loginAdmin' });
              }
            }
          }).catch(err => {
            this.$message.error('数据丢失，试试重新登陆！');
          })
      })
    },

    //审批页面
    handleEdit2: function (index, row) {
      this.userModule = [];
      this.appForm.checkedCities = [];
      this.appForm.id = row.id;
      var moduled = JSON.parse(row.module);
      this.appForm.value = moduled.duration;
      for (var i = 0; i < this.citiesd.length; i++) {
        for (var k = 0; k < moduled.module.length; k++) {
          if (moduled.module[k].id == this.citiesd[i].id) {
            this.appForm.checkedCities.push(this.citiesd[i].modulename);
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }
      // this.appForm= {
      //   id:row.id,
      //   checkedCities:this.userModule,
      //   value:row.value,
      // };
      this.appFormVisible = true;
    },

    handleCheckedCitiesChange(value) {
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }
    },

    //授权页面
    handleEdit: function (index, row) {
      //this.editForm = Object.assign({}, row);
      this.editForm = {
        checkedCities: [],
        value: '',
        id: row.id,
      }
      this.editFormVisible = true;
    },

    forType: function (row, column) {
      if (row.usertype == 1) {
        return row.userType = '企业账号';
      } else {
        return row.userType = '个人账号';
      }
    },
    indexMethod(index) {
      return (index + 1) + (this.pageNumber - 1) * pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    getUser: function (val) {
      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',
        // searchStr:this.souchs.modelName,
        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        registertimefrom: this.souchs.fromtime,
        registertimeto: this.souchs.totime,
        softtype: this.souchs.softtype,
        invitestatus: this.souchs.invitValue,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager:this.successfulManager,
        agencyManager:this.agencyManager,
        searchName: this.searchName,
        isCompanyUser: this.isCompanyUser

      }

      this.downHrefExcel = API_User.allUserByExcel() + "?token=" + this.token +
        "&checkCode=" + this.checkCode +
        "&registertimefrom=" + (this.souchs.fromtime || '') +
        "&registertimeto=" + (this.souchs.totime || '') +
        "&softtype=" + (this.souchs.softtype || '') +
        "&invitestatus=" + (this.souchs.invitestatus || '') +
        "&phone=" + (this.souchs.phone || '') +
        "&company=" + (this.souchs.company || '') +
        "&searchName=" + this.searchName +
        "&isCompanyUser=" + this.isCompanyUser +
        "&managerAdminuser=" + this.managerAdminuser +
        "&fpFlg=" + this.distributionStatus +
        "&username=" + (this.souchs.name || '') + "";
      this.listLoading = true
      API_User.userList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            if (res.data.data) {
              for (var i = 0; i < res.data.data.list.length; i++) {
                res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
                if (res.data.data.list[i].registertime) {
                  res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
                }
              }
              this.total = res.data.data.totalRow;
              this.users = res.data.data.list;
              this.listLoading = false
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(err => {
          this.$message.error('数据丢失，试试重新登陆！');
        });
    },
    getModels: function () {
      let param = {
        token: this.token,
        checkCode: this.checkCode,
      };
      API_Models.getAdminModule(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.models = res.data.data;
            this.cities = [];
            this.citiesd = [];
            for (var i = 0; i < res.data.data.length; i++) {
              this.cities.push(res.data.data[i].modulename);
              var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
              this.citiesd.push(jsones);
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(err => {
          this.$message.error('数据丢失，试试重新登陆！');
        });
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function () {
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        role: this.userInfo.type,
        userId: this.userInfo.id,
      }
      API_Admin.UserList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            // this.yhlx = res.data.data;
            _this.yhlx = [];
            _this.softtypes = [];
            for (var i = 0; i < res.data.data.length; i++) {
              var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name }
              _this.yhlx.push(jsons);
              var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name }
              _this.softtypes.push(json);
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
        });
      param.userType=this.userInfo.type
      API_Admin.tbCompanyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.companyList = res.data.data;
            //_this.yhlx=[];
          }
        });
    },
    getCode2: function () {
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
      }
      API_Admin.AccList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            _this.zhlx = [];
            for (var i = 0; i < res.data.data.length; i++) {
              var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name }
              _this.zhlx.push(jsons);
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
        });
    },

    getCode: function () {
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7,
      }
      API_User.getCode(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            _this.inviValues = [];
            for (var i = 0; i < res.data.data.length; i++) {
              var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name }
              _this.inviValues.push(jsons);
            }
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' });
            }
          }
        });
    },
    // 获取当前登录人所在部门
    getDeptList(companyid) {
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: companyid,
      }
      API_userCom.getDepartList(param).then((res) => {
        if (res.data.code == 200) {
          this.detpList = res.data.data;
        }
      }).catch(err => {
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },

    //取消 新增 批量导入用户
    cancelHandler:function(){
      this.editFormVisible0 = false
      this.deptId=''
    },

    //新增 批量导入用户关闭dialog
    dialogClose(){
      console.log('dialogClose')
      this.deptId=''
    }
  },



}
</script>
<style lang="scss">
.dnnCloud-account-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

.model-user-box {
  .el-form-item__content {
    // position: static !important;
  }
}
</style>
<style scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

a {
  text-decoration: none;
  color: #2196f3;
}

.blue {
  min-width: 60px;
  max-width: 90px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #669df0;
  color: #669df0;
  border-radius: 2px;
}

.purple {
  min-width: 60px;
  max-width: 90px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #be74d9;
  color: #be74d9;
  border-radius: 2px;
}

.gray {
  min-width: 60px;
  max-width: 90px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #666666;
  color: #666666;
  border-radius: 2px;
}

.orange {
  min-width: 60px;
  max-width: 90px;
  text-align: center;
  padding: 3px 12px 3px 12px;
  border: 1px solid #fd945a;
  color: #fd945a;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// Account.vue?78d31b54